/**
 * Oceread 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

/**
 * Oceread 品牌特定主题配置
 */
export const theme = {
  // 头像边框色 (Oceread 使用 #F5F2FF)
  avatarBorder: '#F5F2FF',
  // 按钮背景色 (Oceread 使用 #F3EEFF)
  btnPrimaryBg: '#F3EEFF',
  // VIP 背景图 URL
  vipSubscribeBg: 'url(/images/oceread/member_subscribe_bg.webp)',
} as const

/**
 * Oceread 品牌特定资源配置
 */
export const resources = {
  // 用户背景图
  userBg: '/images/oceread/user-bg.webp',
  // 用户默认头像
  userDefaultAvatar: '/images/oceread/user-default.webp',
  // VIP 图标
  memberVip: '/images/oceread/member-vip.png',
  // VIP 折扣图标
  memberVipDiscount: '/images/oceread/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
}
